import { useState, useEffect } from "react";
import { FiPlus, FiMinus } from "react-icons/fi";
import { useTranslation } from "next-i18next";

const ANSWER_CLAMP_THRESHOLD = 200;

function FaqItem({ item, index, isOpen, onToggle, isLast }) {
  const { t } = useTranslation();
  const question = item.title ?? item.question;
  const answer = item.content ?? item.answer;
  const isLong = (answer?.length ?? 0) > ANSWER_CLAMP_THRESHOLD;
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (!isOpen) setIsExpanded(false);
  }, [isOpen]);

  return (
    <div className={isLast ? "" : "border-b border-[#CDCDCD]"}>
      <button
        type="button"
        onClick={onToggle}
        className="flex w-full items-start justify-between gap-[16px] py-[20px] text-left"
        aria-expanded={isOpen}
      >
        <p className="text-[#0A0A0A] text-[16px] md:text-[24px] font-[600] leading-[140%] pr-[8px]">
          Q{index + 1}. {question}
        </p>
        <span className="mt-[2px] shrink-0 text-main-pink">
          {isOpen ? <FiMinus className="text-[24px]" /> : <FiPlus className="text-[24px]" />}
        </span>
      </button>

      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? "max-h-[2000px] opacity-100 pb-[18px] md:pb-[22px]" : "max-h-0 opacity-0"
        }`}
      >
        <p
          className={`text-[#000000] text-[16px] md:text-[18px] font-[400] leading-[150%] max-w-[90%] transition-all duration-300 ${
            isLong && !isExpanded ? "line-clamp-3" : ""
          }`}
        >
          {answer}
        </p>

        {isLong && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setIsExpanded((prev) => !prev);
            }}
            className="mt-[8px] text-main-pink text-[18px] font-[700] hover:opacity-70 transition-opacity duration-200"
          >
            {isExpanded ? t("seo-page.show-less") : t("seo-page.show-more")}
          </button>
        )}
      </div>
    </div>
  );
}

export default function SeoPageFAQ({ seoPage }) {
  const faqs = seoPage?.faqs;
  const [openId, setOpenId] = useState();

  if (!faqs?.length) return null;

  return (
    <section className="bg-[#F8FAFF] pt-[40px] pb-[80px] md:py-[80px]">
      <div className="max-w-[90%] mx-auto">
        <h2 className="text-center text-[#0A0A0A] text-[36px] font-[700] leading-[120%]">FAQ</h2>

        <div className="mt-[24px] md:mt-[32px]">
          {faqs.map((faq, index) => {
            const id = faq.id ?? index;
            return (
              <FaqItem
                key={id}
                item={faq}
                index={index}
                isOpen={openId === id}
                onToggle={() => setOpenId((prev) => (prev === id ? null : id))}
                isLast={index === faqs.length - 1}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
}
